import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

// import background from "../../zmall.png";
import { image_ip } from "../../services/constants";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { useDispatch } from "react-redux";
import { Rating } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { setError } from "../../services/actions";

export default function StoreCard(props) {
  const nav = useNavigate();
  const diapach = useDispatch();
  const style = {
    textAlign: "end",
    color: "red",
  };
  var is_open;
  const checkOpen = () => {
    const date = new Date();
    let day = date.getDay();
    const hour = date.getHours();
    var store_hour = props.store.store_time[day];
    var store_hour_day_time =
      store_hour && store_hour.day_time ? store_hour.day_time : [];
    is_open = false;
    store_hour_day_time.forEach((obj) => {
      var open_time = obj.store_open_time.split(":");
      var open_hour = open_time[0];

      // var open_minute = open_time[1];
      var close_time = obj.store_close_time.split(":");
      var close_hour = close_time[0];
      // var close_minute = close_time[1];
      // console.log(open_hour);
      // console.log(hour);
      // console.log(close_hour);
      if (
        parseInt(open_hour) < parseInt(hour) &&
        parseInt(hour) < parseInt(close_hour)
      ) {
        is_open = true;
      }
    });
    // console.log(flag);
    return is_open;
  };
  const handleClick = React.useCallback(
    (id) =>
      ({ getItemById, scrollToItem }) => {
        // console.log(props,props.store.store_count,'here to check')
        console.log("store");
        const is_laundary = props.store.name === "SUNSHINE LAUNDRY";
        localStorage.setItem("is_laundary", is_laundary);
        console.log(is_laundary);
        if (is_open) {
          if (props.store.store_count === 1) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            nav(`/singleStor/${id}`, {
              state: {
                store: props.store,
                delivery_id: props.delivery_id,
                name: props.store.name,
              },
            });
          } else if (!props.store.store_count) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            nav(`/singleStor/${id}`, {
              state: {
                store: props.store,
                delivery_id: props.delivery_id,
                name: props.store.name,
              },
            });
          } else {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            nav(`/store/${id}`, {
              state: {
                store: props.store,
                delivery_id: props.delivery_id,
                round: true,
              },
            });
          }
        } else {
          diapach(
            setError({
              error: true,
              message: "soory the store is currently closed",
            })
          );
          console.log("soory the store is currently closed");
        }
        // console.log('since check flag here wether called from delivery or stores it self')
        // if (props.flag == true){
        //   console.log(props,'here to check right')
        //   // props.flag =false
        //   nav(`/singleStor/${id}`, {state:{store:props.store,delivery_id:props.delivery_id}});
        // } else {
        //   console.log(props,'here to not check')
        // nav(`/store/${id}`, {state:{store:props.store,delivery_id:props.delivery_id}});}
      },
    [props]
  );
  return (
    <ListItem
      alignItems="center"
      onClick={handleClick(props.store._id)}
      style={{ paddingLeft: "8px" }}
    >
      <ListItemAvatar>
        {/* <Avatar alt="zmall.png" src={background} /> */}
        <Avatar
          variant="square"
          src={`${image_ip}${props.store.image_url}`}
          sx={{ width: 60, height: 60 }}
          onError={({ currentTarget }) => {
            // console.log('erroringgggggggggggggg',currentTarget)
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = "/zmall.png";
          }}
        />
      </ListItemAvatar>
      <ListItemText
        primaryTypographyProps={{ fontSize: "0.8rem" }}
        style={{ marginLeft: "8px" }}
        secondaryTypographyProps={{ fontSize: "0.7rem" }}
        primary={props.store.name}
        secondary={
          <React.Fragment>
            <Typography
              sx={{ display: "inline" }}
              component="span"
              variant="body2"
              color="text.primary"
            >
              {Math.round(props.store.distance * 100) / 100}
            </Typography>
            <span></span>away
            <br></br>
            <Rating
              name="read-only"
              style={{ fontSize: "0.8rem" }}
              value={props.store.user_rate}
              readOnly
            />
            <br></br>
            {checkOpen() ? (
              <span style={{ color: "green" }}>open</span>
            ) : (
              <span style={{ color: "red" }}>close</span>
            )}
            {/* <Button size="small" onClick={handleClick(props.store._id)} >See</Button> */}
          </React.Fragment>
        }
      />
      <ListItemText>
        <React.Fragment>
          <div style={style}>
            <ArrowForwardIosIcon />
          </div>
        </React.Fragment>
      </ListItemText>
    </ListItem>
  );
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardMedia
        component="img"
        height="140"
        // image={`http://196.189.44.49:7000/${props.store.image_url}`}
        image="zmall.png"
        alt="unable to load image"
      />
      <CardContent>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          style={{ fontSize: "0.7rem" }}
        >
          {props.store.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {props.store.address}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {props.store.rating}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" onClick={handleClick(props.store._id)}>
          See More
        </Button>
      </CardActions>
    </Card>
  );
}
